import WidgetWrapper from '@/components/Payments/common/WidgetWrapper'
import { memo } from 'react'

function HoldingCard({
  logoComp,
  nameComp,
  qtyComp,
  bottomComp,
  handleClick,
  bottomStripComp,
}: {
  logoComp?: JSX.Element | null
  nameComp?: JSX.Element | null
  qtyComp?: JSX.Element | null
  bottomComp?: JSX.Element | null
  bottomStripComp?: JSX.Element | null
  handleClick?: Function
}) {
  return (
    <WidgetWrapper
      borderClass="border-0 rounded-lg"
      shadowClass="shadow-one"
      backgroundClass="bg-white"
      wrapperClass="p-0 my-1"
    >
      <div
        className="flex cursor-pointer flex-col"
        onClick={() => {
          if (handleClick) {
            handleClick()
          }
        }}
      >
        <div className="relative box-border flex appearance-none items-center justify-between p-4">
          <div className="flex w-full justify-between ">
            <div className="flex gap-2">
              {logoComp}
              {nameComp}
            </div>
            {qtyComp}
          </div>
        </div>
        <div>{bottomComp}</div>
      </div>
      {bottomStripComp}
    </WidgetWrapper>
  )
}

export default memo(HoldingCard)
